/* Editorial context and allowlisted analytics only. Location remains in the existing tools. */
(function () {
  'use strict';
  if (window.ArventoTravel) return;
  var intents = {
    intent_return: ['return_point', 'return-point'],
    intent_help: ['nearby_essentials', 'nearby-essentials'],
    intent_bike_help: ['bike_shop', 'arvento-bike-shop'],
    intent_ride: ['cycling_hotspot', 'cycling-hotspot-trust'],
    intent_workout: ['workout_nearby', 'workout-nearby'],
    intent_share: ['share_location', 'share-location']
  };
  var regions = ['asia', 'europe', 'north-america', 'south-america'];
  var tools = ['return_point', 'nearby_essentials', 'bike_shop', 'cycling_hotspot', 'workout_nearby', 'share_location', 'local_food_stories'];
  var actions = ['save', 'return', 'clear', 'search', 'location', 'copy_help', 'copy_taxi', 'share'];
  var results = ['saved', 'cleared', 'near_start', 'map_handoff', 'location_ready', 'copied', 'shared', 'recommendations_ready', 'permission_denied', 'unavailable', 'timeout', 'unsupported', 'insecure', 'low_accuracy', 'no_saved_point', 'storage_unavailable', 'no_results', 'request_failed', 'copy_failed', 'invalid_input', 'not_ready'];
  var contexts = Object.create(null);

  function analyticsAllowed() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (_) { return false; }
  }

  function emit(event, fields) {
    if (!analyticsAllowed()) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({event: event, page: 'travel_tools_hub'}, fields));
    } catch (_) { /* Analytics must never interrupt an existing tool. */ }
  }

  function cityContext(city, section, intent) {
    var nodes = document.querySelectorAll('[data-ta-city][data-ta-section][data-ta-intent]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.dataset.taCity === city && n.dataset.taSection === section && n.dataset.taIntent === intent &&
          /^[a-z][a-z0-9-]{0,39}$/.test(city) && /^[a-z][a-z0-9-]{0,39}$/.test(section)) {
        return {city: city, source_section: section};
      }
    }
    return {};
  }

  function contextFrom(link, intent) {
    var context = {source_intent: intent};
    if (regions.indexOf(link.dataset.taRegion) !== -1) context.region = link.dataset.taRegion;
    return Object.assign(context, cityContext(link.dataset.taCity, link.dataset.taSection, intent));
  }

  function report(event, tool, action, result) {
    if (['start', 'success', 'error'].indexOf(event) === -1 || tools.indexOf(tool) === -1 || actions.indexOf(action) === -1) return;
    var fields = Object.assign({tool: tool, action: action}, contexts[tool] || {});
    if (results.indexOf(result) !== -1) fields.result = result;
    emit('travel_tool_' + event, fields);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-ta-intent]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var intent = link.dataset.taIntent;
    var mapping = intents[intent];
    if (!mapping) return;
    var context = contextFrom(link, intent);
    contexts[mapping[0]] = context;
    var fields = Object.assign({intent: intent, tool: mapping[0]}, context);
    delete fields.source_intent;
    emit('travel_assistant_intent_click', fields);
    if (context.region) emit('travel_tool_region_context_click', {region: context.region, intent: intent, tool: mapping[0]});
    if (context.city) emit('travel_tool_city_referral', {city: context.city, tool: mapping[0], source_section: context.source_section});
    // Native anchors remain the no-JS path; focus moves to the real control/section.
    var target = document.getElementById(mapping[1]);
    if (target && link.getAttribute('href') === '#' + mapping[1]) {
      if (!target.matches('button, input, a')) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll: true});
    }
  }, {capture: true}); // Observe before Prestige's delegated smooth-scroll cancels native navigation.

  function acceptReferral() {
    var query = new URLSearchParams(window.location.search);
    var intent = query.get('ta_intent');
    if (!intents[intent]) return;
    var context = cityContext(query.get('ta_city'), query.get('ta_section'), intent);
    if (!context.city) return;
    contexts[intents[intent][0]] = Object.assign({source_intent: intent}, context);
    emit('travel_tool_city_referral', {city: context.city, tool: intents[intent][0], source_section: context.source_section});
  }

  window.ArventoTravel = {report: report};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', acceptReferral, {once: true});
  else acceptReferral();
})();
